<template lang="pug">
  modal(:title='$t("team.deleteMembersModal.title")' @closeModal='closeModal')
    .column
      .column.text-container
        p.text-normal.m-bottom-2 {{ $t("team.deleteMembersModal.title") }}
        ul.m-left-2
          li.item.m-bottom-1.row.middle(v-for='user in selectedUsers') {{ user.fullName || user.email }}
      .row.center
        button.main-button.white.continue.m-right-6(@click='closeModal' type='button')
          | {{ $t("team.deleteMembersModal.cancel") }}
        button.main-button.no-border(@click='deleteMembers' type='button')
          | {{ $t("team.deleteMembersModal.confirm") }}
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { i18n } from '../../main'

import Modal from '../Modal'

export default {
  props: {
    pageNumber: { type: Number }
  },
  components: { Modal },
  computed: {
    ...mapState({
      selectedUsers: state => state.team.selectedUsers,
      storeProps: state => state.behavior.deleteMembersModal.props,
      currentSchool: state => state.profile.userProfile.schoolGroupVO.currentSchool
    })
  },
  methods: {
    ...mapActions([
      'showElement',
      'hideElement',
      'deleteUsers',
      'deselectAllTeamUsers'
    ]),
    closeModal() {
      if (this.storeProps && this.storeProps.single) this.deselectAllTeamUsers()
      this.hideElement({ element: 'deleteMembersModal' })
    },
    async deleteMembers() {
      const success = await this.deleteUsers(this.currentSchool.id)
      this.hideElement({ element: 'deleteMembersModal' })
      if (success) {
        this.$notify({
          group: 'custom-toast',
          duration: 5000,
          text: i18n.t('team.deletedSuccess'),
          type: 'success'
        })
        this.$emit('deletedUsers', this.pageNumber)
      } else {
        this.$notify({
          group: 'custom-toast',
          duration: 5000,
          text: i18n.t('team.deletedError'),
          type: 'error'
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/variables/colors';

.discard-modal {
  .modal-container {
    max-width: 464px;
  }
}

.text-container {
  margin: 25px 0 48px;
}

.item{
  &::before {
    background-color: $dark-gray;
    border-radius: 100%;
    content: '';
    height: 8px;
    margin-right: 10px;
    position: relative;
    min-width: 8px;
    width: 8px;
  }
}

</style>
